import { Routes } from '@angular/router';
import { SepDashboardComponent } from './sep-dashboard.component';

export const ModuleRoutes: Routes = [
    {
        path: '',
        component: SepDashboardComponent
    }
]
